import React  from 'react';
import {Link} from 'react-router-dom'
import SideNavigationNumberedLabel from "./SideNavigationNumberedLabel";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
	return {
		bookLabel: state.countyConfigCommonReducer.bookLabel
	};
}

class SideNavigationNumberedNavLink extends React.Component {
    render(){
       let currentSearchIndicator = '';
       if (this.props.index === 1) {
       		currentSearchIndicator = 'Current';
       }

       let minWidth = 0
       if (this.props.sideNavigationOpen) {
           minWidth = 250
       }

       let className = "side-numbered-navlink";
       if (this.props.index === 5) {
           className += " side-numbered-navlink-last"
       }

       let historyLink = '/search/searchHistory/' + this.props.type + '/' + this.props.index;

       let description = this.props.description;
       if (description === 'Book and Page'){
            description =this.props.bookLabel + " and Page";
       }

       return(
          <Link to={historyLink} style={{ minWidth:minWidth}} className={className}><SideNavigationNumberedLabel {...{ number: this.props.index, name: description, title:this.props.criteriaDescription, badge:currentSearchIndicator}} /></Link>
       )
     }
}
export default connect(mapStateToProps)(SideNavigationNumberedNavLink);